import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Checkbox } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    VirtualizedTableItemValue,
    VirtualizedTableProps,
    VirtualizedTableConfirmationCheckboxModal
} from 'services/virtualizedTable/types';
import { setItemValue } from 'services/virtualizedTable/actions';
import {
    makeSelectVirtualizedTableItemValueAsBoolean,
    makeSelectVirtualizedTableColumnConfirmationModal
} from 'services/virtualizedTable/selectors';

import { updateQueryString } from 'services/router/actions';

type OwnProps = VirtualizedTableProps;

interface ConnectedProps {
    checked?: VirtualizedTableItemValue;
    confirmationModal?: VirtualizedTableConfirmationCheckboxModal;
}

interface DispatchProps {
    setItemValue: typeof setItemValue;
    updateQueryString: typeof updateQueryString;
}

export type Props = OwnProps & ConnectedProps & DispatchProps;

export class VirtualizedTableConfirmationCheckboxComponent extends React.PureComponent<
    Props
> {
    checkboxInput = React.createRef<HTMLInputElement>();

    handleChange = (event: React.FormEvent<HTMLInputElement>): void => {
        const {
            checked,
            itemKey,
            columnKey,
            confirmationModal,
            ...props
        } = this.props;

        if (confirmationModal) {
            props.updateQueryString({
                [confirmationModal]: true,
                itemKey,
                columnKey
            });
        }
    };

    handleClick = (event: React.MouseEvent<HTMLInputElement>): void => {
        event.stopPropagation();
    };

    render(): React.ReactElement | null {
        const { checked } = this.props;

        return (
            <Checkbox
                onChange={this.handleChange}
                onClick={this.handleClick}
                checked={checked}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    checked: makeSelectVirtualizedTableItemValueAsBoolean(),
    confirmationModal: makeSelectVirtualizedTableColumnConfirmationModal()
});

export default connect(mapStateToProps, {
    setItemValue,
    updateQueryString
})(VirtualizedTableConfirmationCheckboxComponent);
